/** Matches punctuation-insensitive words while preserving the order of dimension pairs. */
export function matchesTemplateSearch(text: string, search: string): boolean {
  const searchWords = toSearchWords(search);
  if (searchWords.length === 0) {
    return true;
  }
  const normalizedText = normalizeForSearch(text);
  return searchWords.every((word) => normalizedText.includes(word));
}

function toSearchWords(search: string): string[] {
  const normalized = normalizeForSearch(search);
  return normalized.length === 0 ? [] : normalized.split(" ");
}

function normalizeForSearch(value: string): string {
  return (
    value
      .toLowerCase()
      // Keep dimension pairs together, including incomplete pairs entered while typing.
      .replace(/(\d)\s*[x×]\s*/g, "$1x")
      .replace(/[^a-z0-9]+/g, " ")
      .trim()
  );
}
